export const extractAndSaveToDataLayer = (loguedAs) => {
  if (!loguedAs || typeof loguedAs !== 'object') {
    return;
  }

  const { doc_type, doc_number, email } = loguedAs;

  if (!doc_type || !doc_number || !email) {
    return;
  }

  const dataLayerObject = {
    docType: doc_type,
    docNumber: doc_number,
    email,
  };

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.unshift(dataLayerObject);
};
